import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface ExitEditConfirmationDialogProps {
  isOpen: boolean
  onConfirm: (action: 'save' | 'discard') => void
  onCancel: () => void
  isSaving?: boolean
}

/**
 * Confirmation dialog shown when user tries to exit edit mode with unsaved changes
 */
export function ExitEditConfirmationDialog({
  isOpen,
  onConfirm,
  onCancel,
  isSaving = false
}: ExitEditConfirmationDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Unsaved Changes</DialogTitle>
          <DialogDescription>
            You have unsaved changes. What would you like to do?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button 
            variant="outline" 
            onClick={onCancel}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={() => onConfirm('discard')}
            disabled={isSaving}
          >
            Discard Changes
          </Button>
          <Button 
            onClick={() => onConfirm('save')}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save & Exit'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
} 